<template>
  <guide
    v-model='wiz'
    :loading='globalInitLoading'
    :progress='progress' >

    <v-timeline-item hide-dot
      slot='profile-timeline-after'
      class="mt-0 mb-6 caption font-weight-bold" >

      <v-list subheader dense class="pa-0 ma-0" >
        <v-subheader >Looking good {{ meFirstName }}</v-subheader>
        <v-list-item >
          <v-list-item-avatar >
            <img v-if='meProfile' :src="meProfile" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="meFullname" />
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- <pre v-text='me' /> -->
    </v-timeline-item>

    <!-- spaces -->
    <v-timeline-item slot='space-timeline-after'
      class="mb-6" hide-dot >
      <v-btn to='/settings/spaces' small outlined >Manage spaces</v-btn>
      <v-btn @click="launchNewSpaceWizard" small outlined class='ml-2' color='primary' >
        <v-icon>mdi-plus</v-icon>
        New space</v-btn>
      <div v-if='hasSpaces' class='mt-2'>
        <strong class='mt-3 caption text-uppercase font-weight-medium' >Your spaces:</strong>
        <space-chip
          v-for='(space, index) in spacesIOwn'
          :key='space.id'
          v-model='spacesIOwn[index]'
          @selected="$router.push(`/settings/spaces/${space.id}`)"
          class='ma-2' color='primary' />
      </div>
    </v-timeline-item>

    <!-- locations -->
    <v-timeline-item
      v-if='hasSpaces'
      slot="location-timeline-after"
      class="mb-6" hide-dot >
      <div
        v-for='space in spacesIOwn' :key='space.id' class='mb-3' >
        <strong class='caption text-uppercase font-weight-medium'>{{space.title}}:</strong><br/>
        <location-chip
          v-for='loc in space.locations'
          @selected="gotoLocation(space, loc)"
          :space-id='space.id'
          :location-id='loc.id'
          :key='loc.id'
          :attrs='{small: true}'
          class='ma-1' />
        <v-chip class='ma-1' @click='launchNewLocationWizard(space.id)' small ><v-icon left small >mdi-plus</v-icon> New location</v-chip>
      </div>

    </v-timeline-item>

    <v-timeline-item
      v-if='practitionersList && practitionersList.length > 0'
      slot="invite-timeline-after"
      class="mb-6" hide-dot >

        <strong class='caption text-uppercase font-weight-medium'>Colleagues:</strong><br/>
        <v-chip
          v-for='p in practitionersList'
          :to="`/settings/team/${calculatedBusinessId}/${p.id}`"
          :key='p.id' small class='ma-1 pl-1' >
          <v-avatar left color="cyan white--text" >
            <v-img :src='getProfilePicture(p)' v-if="getProfilePicture(p)" />
            <span v-else-if="p.full_name" >{{p.full_name[0]}}</span>
          </v-avatar>
          {{p.full_name}}
        </v-chip>

        <v-chip small class='ma-1' @click="launchInviteWizard" >
          <v-icon left small >mdi-plus</v-icon>
          Add a teammate
        </v-chip>

    </v-timeline-item>

  </guide>
</template>
<script>
import Guide from '@/components/actions/guides/Guide.vue'
import SpaceChip from '@/components/listitems/SpaceChip.vue'
import LocationChip from '@/components/listitems/LocationChip.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'GetStartedGuide',
  components: { Guide, SpaceChip, LocationChip },
  computed: {
    ...mapGetters('identity', [
      'getLocations',
      'productsList',
      'practitionersList',
      'me',
      'meId',
      'meProfile',
      'meFirstName',
      'meFullname',
      'spacesIOwn'
    ]),
    wiz () {
      let hasSpaces = this.hasSpaces
      let hasLocations = false
      let numLocations = 0
      if (this.hasSpaces) {
        this.spacesIOwn.forEach ((space) => {
          if (space.locations) {
            hasLocations = true
            this.numLocations += space.locations.length
          }
        })
      }

      if (this.isActorDependent === true) {
        return {
          title: 'Configure your account',
          icon: 'mdi-cog',
          steps: [
            {
              id: 'profile',
              title: 'Set up your profile',
              description: 'Make sure your personal information is correct',
              done: true,
              editText: 'Edit',
              onclick: () => {
                this.$router.push({ path: '/settings/me/profile' })
              }
            }
          ]
        }
      }

      return {
        title: 'Configure your account',
        icon: 'mdi-cog',
        steps: [
          {
            id: 'profile',
            title: 'Set up your profile',
            description: 'Make sure your personal information is correct',
            done: true,
            editText: 'Edit',
            onclick: () => {
              this.$router.push({path: '/settings/me/profile'})
            }
          },
          {
            id: 'space',
            title: 'Create a space',
            description: 'A space is your business or practice',
            done: hasSpaces,
            onclick: () => {
              this.$router.push({path: '/wizards/space'})
            }
          },
          {
            id: 'location',
            title: 'Add some locations',
            description: 'Locations are the addresses or virtual locations that you work from',
            done: (hasSpaces && hasLocations),
            disabled: !hasSpaces,
            editText: 'Edit',
            onclick: () => {
              if (hasLocations) {
                this.$router.push({path: '/settings/spaces/--/locations'})
              } else {
                this.launchNewLocationWizard()
              }
            },
            data: {
              hasLocations,
              numLocations
            }
          },
          {
            id: 'products',
            title: 'Add your appointment types',
            description: 'Apppointment types are like templates for your appointments',
            done: (hasSpaces && this.productsList.length > 0),
            disabled: !hasSpaces,
            editText: 'Edit',
            onclick: () => {
              this.launchQuickCreateAppointmentType()
            }
          },
          {
            id: 'invite',
            title: 'Manage your team',
            description: 'Add colleagues to your spaces',
            done: (hasSpaces && this.productsList.length > 0),
            disabled: !hasSpaces,
            cta: 'Manage Team',
            editText: 'Manage Team',
            // editText: 'Edit',
            onclick: () => {
              // this.launchInviteWizard()
              this.$router.push({path: '/settings/team'})
              // this.$router.push({path: '/settings/spaces/--/locations'})
            }
          }
        ]
      }
    },
    progress () {
      let numSteps = this.wiz.steps.length
      let completeSteps = this.wiz.steps.filter((step) => { return step.done }).length
      return completeSteps / numSteps * 100
    },
    hasSpaces () {
      if (this.spacesIOwn && this.spacesIOwn.length > 0) { return true }
      return false
    }
  },
  methods: {
    gotoLocation (space, location) {
      let path = `/settings/spaces/${space.id}/locations/${location.id}`
      this.$router.push({path})
    }
  }
}
</script>
